import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import BasePage from '@ts-core/pages/BasePage';
import ExercisePreviewHandler from '@ts-core/modules/exercises/components/ExercisePreviewHandler';
import ResultCard from '@ts-core/core/components/ResultCard/ResultCard';

import { StudentPracticeSession } from '../../types';

interface StudentPracticeSessionResultProps {
  practiceSession?: StudentPracticeSession;
  loading?: boolean;
}

const StudentPracticeSessionResult = (props: StudentPracticeSessionResultProps) => {
  const { practiceSession, loading = false } = props;

  if (loading) {
    return (
      <Box width="100%" textAlign="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <BasePage>
      <Box display="flex" flexDirection="row" justifyContent="center" mt={2}>
        <ResultCard score={practiceSession?.score} maxScore={practiceSession?.maxScore} />
      </Box>
      {practiceSession?.exercises?.map((exercise) => (
        <ExercisePreviewHandler exercise={exercise} key={exercise.id} />
      ))}
    </BasePage>
  );
};

export default StudentPracticeSessionResult;
